import Reveal from "../Reveal";

const steps = [
  {
    n: "01",
    title: "Gratis adviesgesprek",
    desc: "We komen vrijblijvend bij u thuis of op locatie. We luisteren, meten op en bespreken de mogelijkheden — geen verplichtingen, wel duidelijkheid.",
  },
  {
    n: "02",
    title: "Ontwerp & offerte",
    desc: "U ontvangt een transparant ontwerpvoorstel met materiaalkeuzes, planning en vaste prijs. Eerlijk, gedetailleerd en zonder verrassingen achteraf.",
  },
  {
    n: "03",
    title: "Vakkundige uitvoering",
    desc: "Onze ervaren specialisten realiseren uw badkamer of toilet van A tot Z. Eén aanspreekpunt, schoon werk en strakke planning.",
  },
  {
    n: "04",
    title: "Oplevering & garantie",
    desc: "We leveren op met aandacht voor detail, geven instructies en garantie. Tevredenheid is geen extra — het is het uitgangspunt.",
  },
];

export default function Process() {
  return (
    <section
      id="werkwijze"
      data-testid="process-section"
      className="bg-[#F5F7FB] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <div className="max-w-3xl">
            <span className="tag-overline">03 — Werkwijze</span>
            <h2 className="mt-4 text-5xl md:text-6xl text-[#0A0A0A] leading-[1.02] uppercase tracking-tight">
              Helder traject,
              <br />
              <span className="text-[#1E5BC6]">zorgeloos resultaat.</span>
            </h2>
          </div>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-x-16">
          {steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 90}>
              <div
                data-testid={`process-step-${i}`}
                className="relative py-10 border-b border-[#E5E7EB] flex items-start gap-7"
              >
                <div className="text-6xl md:text-7xl text-[#1E5BC6]/25 leading-none select-none font-extrabold tracking-tighter">
                  {s.n}
                </div>
                <div className="flex-1 pt-2">
                  <h3 className="text-2xl md:text-3xl text-[#0A0A0A] uppercase tracking-tight">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-[#5A5A5A] leading-relaxed max-w-md">
                    {s.desc}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
